import { useEffect, useRef, useState } from "react";
import { useGlobalContext } from "src/context/useGlobalContext";
import ContactMeForm from "../contactMeForm/ContactMeForm";

const ContactMeModal = () => {
	
	const { navigate, getQueryParameter } = useGlobalContext();

	const [show, SetShow] = useState(false);
	const [showContactMeModal, SetShowContactMeModal] = useState(false);

	const showContactMeModal_inPath = getQueryParameter('show-contact-me-modal');

	useEffect(() => {
        if(showContactMeModal_inPath) SetShowContactMeModal(true);
        else setTimeout(() => SetShowContactMeModal(false), 200);

        // --eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showContactMeModal_inPath])

	useEffect(() => {
		if (showContactMeModal_inPath) setTimeout(() => SetShow(true), 100);
		else SetShow(false);
	}, [showContactMeModal_inPath]);

	return showContactMeModal ? (
		<div
			className={`contact-me-modal ${show ? "show" : ""}`}
			data-type="modal"
		>
			<div className="container p-2 w-[80vw] lg:px-10 lg:py-5 lg:w-min">
				<div className="w-full max-w-[1280px] pb-10 flex justify-center text-4xl">
					Contact me
				</div>
				<ContactMeForm />
				<div className="w-full flex justify-end">
					<button
						className=""
						onClick={(e) => navigate(-1)}
					>
						Close
					</button>
				</div>
			</div>
		</div>
	) : '';
};

export default ContactMeModal;
